import { h, Component } from 'preact';
import { route } from 'preact-router';
import { translate } from 'react-i18next';


class LinkedAccountsHandler extends Component {

  getURLParam = ( name, url ) => {
  	if (!url) url = location.href;
  	name = name.replace(/[\[]/,'\\\[').replace(/[\]]/,'\\\]');
  	let regexS = '[\\?&]'+name+'=([^&#]*)';
  	let regex = new RegExp( regexS );
  	let results = regex.exec( url );
  	return results == null ? null : results[1];
  }

  processTwitch = () => {
  	// fetch code param from url
  	if (this.getURLParam('code',window.location.href)) {
  		let code = this.getURLParam('code',window.location.href);
  		fetch('https://api.twitch.tv/kraken/oauth2/token', {
  			method: 'post',
  			headers: {
  				'Content-Type': 'application/json'
  			},
  			body: `{"client_id": "przn0eyaxn1pm3ujt4qs9dh3tjbgnr", "client_secret": "2ozop6btnez1ttv449klaqkn2zwd8d", "grant_type":"authorization_code","redirect_uri":"https://my.hirezstudios.com/linked-accounts/twitch","code":"${code}"}`
  		}).then((response) => response.json()).then((response) => {
  			let access_token = response.access_token;
  			// get user data from Twitch
  			fetch(`https://api.twitch.tv/kraken/user?oauth_token=${access_token}`, {
  				method: 'get'
  			}).then((response) => response.json()).then((response) => {
          let user_id = response._id;
  				// put hirez user account on heartbeat service
  				fetch(`https://api.twitch.tv/kraken/user/vhs?identifier=HR9307314&api_version=5&client_id=vlisrbyc1op7ejvhgg5nhdbtax57iq&oauth_token=${access_token}`, {
  					method: 'put'
  				}).then((response) => response.json()).then((response) => {
            // TODO: fetch api.hirezstudios.com link endpoint for Twitch
            if (1 === 1) { // TODO: better check here for above PUT
              fetch(`https://api.hirezstudios.com/acct/link`, {
              method: 'post',
              headers: {
                'Content-Type': 'application/json'
              },
              body: `{"webToken": "b31628c240844cafbfbe205b2c2011ce", "platform": "Twitch", "platformUserId": "${user_id}", "country": "US", "accessToken": "${access_token}"}`
              }).then((response) => {
                route('/linked-accounts', true);
            });
            }
  				});
  			});
  		});
  	}
  }

  processFacebook = () => {
    if (this.getURLParam('code',window.location.href)) {
      let code = this.getURLParam('code',window.location.href);
      fetch(`https://graph.facebook.com/v2.11/oauth/access_token?client_id=968092606547648&redirect_uri=https://my.hirezstudios.com/linked-accounts/facebook&client_secret=513b8b90e21e5b0b8b8239dc5a8ef5b5&code=${code}`, {
  					method: 'get'
  		}).then((response) => response.json()).then((response) => {
        let access_token = response.access_token;
  			fetch(`https://graph.facebook.com/me?access_token=${access_token}`, {
  					method: 'get'
  			}).then((response) => response.json()).then((response) => {
          let user_id = response.id;
  				fetch(`https://graph.facebook.com/oauth/access_token?grant_type=fb_exchange_token&client_id=968092606547648&client_secret=513b8b90e21e5b0b8b8239dc5a8ef5b5&fb_exchange_token=${access_token}`, {
  					method: 'get'
          }).then((response) => response.json()).then((response) => {
            let long_access_token = response.access_token;
              fetch(`https://api.hirezstudios.com/acct/link`, {
              method: 'post',
              headers: {
                'Content-Type': 'application/json'
              },
              body: `{"webToken": "b31628c240844cafbfbe205b2c2011ce", "platform": "FacebookPaladins", "platformUserId": "${user_id}", "country": "US", "accessToken": "${long_access_token}"}`
              }).then((response) => {
                if (response.status === 200) {
                  route('/linked-accounts', true);
                } else {
                  // TODO: update link?
                }
            });
          });
        });
      });
    }
  }


	// TODO: Fix redirect_uri with actual redirect_uri once whitelisted
  processPlaystation = () => {
		if (this.getURLParam('code',window.location.href)) {
			let code = this.getURLParam('code',window.location.href);
			fetch('https://auth.api.sonyentertainmentnetwork.com/2.0/oauth/token', {
  			method: 'POST',
  			headers: {
					'Authorization': `Basic NTZlMDNmZTUtYzliZS00ZWY1LTk3MjItOWI4YmM2YmFlMTkwOjEza2UyU2lkRFZCc3M1ZzM=`,
					'Content-Type': 'application/x-www-form-urlencoded'
  			},
				body: `"grant_type=authorization_code&redirect_uri=https://www.hirezstudios.com/link/playstation&code=${code}"`
  		}).then((response) => response.json()).then((response) => {
				if (response.hasOwnProperty('access_token')) {
					fetch(`https://auth.api.sonyentertainmentnetwork.com/2.0/oauth/token/${response.access_token}`, {
						method: 'GET',
						headers: {
							'Authorization': `Basic NTZlMDNmZTUtYzliZS00ZWY1LTk3MjItOWI4YmM2YmFlMTkwOjEza2UyU2lkRFZCc3M1ZzM=`,
							'Content-Type': 'application/x-www-form-urlencoded'
						}
					}).then((response) => response.json()).then((response) => {
						if (response.hasOwnProperty('user_id')) {
							fetch('https://api.hirezstudios.com/acct/link', {
								method: 'POST',
								headers: {
									'Content-Type': 'application/json'
								},
								body: `{"platformAccountId": "${response.user_id}", 
									"platform": "ps4",
									"country": "${response.country_code}",
									"webToken": "${this.context.userData.webToken}"
								}`
							}).then((response) => response.json()).then((response) => {
								if (response.statusCode === 200) {
									route('/linked-accounts', true);
								}
								else {
									// account link failed at hirez
								}
							});
						}
						else {
							// account linked failed at playstation
						}
					});
				} else {
					// account link failed at playstation
				}
			});
		}
  }
// TODO: Fix redirect_uri with actual redirect_uri once whitelisted
  processXbox = () => {
    if (window.location.hash.indexOf('access_token') >= 0) {
			let accessToken = window.location.hash.split('&')[0].substring(14);
			fetch('https://user.auth.xboxlive.com/user/authenticate', {
  			method: 'POST',
  			headers: {
					'Content-Type': 'application/json',
					'x-xbl-contract-version': 0
  			},
				body: `{"RelyingParty": "http://auth.xboxlive.com", 
								"TokenType": "JWT", 
								"Properties": {
									"AuthMethod": "RPS",
									"SiteName": "user.auth.xboxlive.com",
									"RpsTicket":"d=${accessToken}"
								}
							}`
  		}).then((response) => response.json()).then((response) => {
				fetch('https://xsts.auth.xboxlive.com/xsts/authorize', {
					method: 'POST',
					headers: {
						'Content-Type': 'application/json',
						'x-xbl-contract-version': 1
					},
					body: `{"RelyingParty": "http://xboxlive.com", 
									"TokenType": "JWT", 
									"Properties": {
										"UserTokens": ["${response.Token}"],
										"SandboxId": "RETAIL"
									}
								}`
				}).then((response) => response.json()).then((response) => {
					if (response.hasOwnProperty('xui')) {
						fetch('https://api.hirezstudios.com/acct/link', {
							method: 'POST',
							headers: {
								'Content-Type': 'application/json'
							},
							body: `{"platformAccountId": "${response.xui.xid}", 
								"platform": "xbox",
								"country": "US",
								"webToken": "${this.context.userData.webToken}"
							}`
						}).then((response) => response.json()).then((response) => {
							if (response.statusCode === 200) {
								route('/linked-accounts', true);
							}
							else {
								// account link failed at hirez
							}
						});
					}
					else {
						// account linked failed at xbox
					}
				})
			});
		}
	}

  noService = () => {
    route('/linked-accounts', true);
  }

  componentDidMount() {
  	window.scrollTo(0,0);
  	switch (this.props.service) {
  		case 'facebook':
  			this.processFacebook();
  			break;
  		case 'twitch':
  			this.processTwitch();
  			break;
  		case 'playstation':
  			this.processPlaystation();
  			break;
  		case 'xbox':
  			this.processXbox();
				break;
  		default:
  			this.noService();
  	}
  }

  render() {
		const { t } = this.props;
  	return (
  		<div className="v-linked-accounts-handler">
  			<h1>{t(`Please wait while we connect your Hi-Rez Studios Account to ${this.props.service}.`)}</h1>
  			<div class="spinner">
  				<div class="bounce1" />
  				<div class="bounce2" />
  				<div class="bounce3" />
  			</div>
  		</div>
  	);
  }
}

export default translate(['common'], { withRef: true })(LinkedAccountsHandler);


// WEBPACK FOOTER //
// ./components/views/LinkedAccountsHandler.js